import React, { FunctionComponent } from "react";

interface UserIconProps {
  url: string;
  height?: string;
  width?: string;
}

const UserIcon: FunctionComponent<UserIconProps> = props => {
  return (
    <img
      src={props.url}
      alt="icon"
      height={props.height ? props.height : "60"}
      width={props.width ? props.width : "60"}
    />
  );
};

export default UserIcon;
